import React from "react";
import { getImageProduct } from "../ultils";
import { Link } from "react-router-dom";
const ProductItem = ({ item }) => {
    return (
        <div className="product-item card text-center">
            <Link to={`/productDetails-${item._id}`}><img src={getImageProduct(item.thumbnail)} /></Link>
            <h4><Link to={`/productDetails-${item._id}`}>{item.name}</Link></h4>
            <p>Giá Bán: <span>{Number(item.price).toLocaleString('vi-VN')}đ</span></p>
        </div>
    )
}
export default ProductItem;